import React, {useState, useEffect} from 'react';
import { Container } from 'reactstrap';
import Buttons from '../buttons';
import { Enums, Utilities } from "@utils";
import { AEAPopOver } from "@/components/";
import FollowUpFinancialDetail from './financial-detail';
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";

export interface IFinancialProps{    
    projectData: any;
    screen: string;
    activeTab: number;
    setFinancialActData: Function;
}

const FollowupFinancial: React.FC<IFinancialProps> = ({projectData, screen, activeTab, setFinancialActData}: IFinancialProps) =>  {
    const [dataColumns, setDataColumns] = useState(null);
    const [auxScreen, setAuxScreen] = useState(screen);
    const [dimensionData, setDimensionData] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [sectionData, setData] = useState<any>(null);
    const [tableAlert, setTableAlerts] = useState<any>(null);
    const [initialValidate, setInitialValidate] = useState<any>(true);
    const [finishTour, setFinishTour] = useState(false);

    const [missedFinancialActData, setMissedFinancialActData] = useState<any>([]);
    

    const view: IFollowupSubproject = {
        state: {
            sectionData,
            projectData,
            refresh,
            dimensionData,
            dataColumns,
            setDataColumns,
            setDimensionData,
            setRefresh,
            setData,
            setTableAlerts,
            setInitialValidate,
            missedFinancialActData,
            setMissedFinancialActData
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    useEffect(() => {
        let isSubscribed = true;
        presenter.initFinancial()
        return () => {(isSubscribed = false)}
    }, []);

    useEffect(() => {
        if(!!missedFinancialActData.length) {
            setFinancialActData(missedFinancialActData)
        }
    }, [missedFinancialActData]);

    useEffect(() => {
        let isSubscribed = true;
        if(activeTab === 2){
            if(sectionData && presenter.stepData && dimensionData && presenter.resultsFramework) presenter.unSetLoading()
            else presenter.keepLoading()
        }
        return () => {(isSubscribed = false)}
    }, [sectionData, presenter.stepData, dimensionData, presenter.resultsFramework, activeTab]);

    useEffect(() => {
        let isSubscribed = true;
        if(presenter.subProjectDimensions?.length) presenter.getDimensionData(Enums.FollowupDimensions.financial)
        return () => {(isSubscribed = false)}
    }, [presenter.subProjectDimensions]);

    useEffect(() => {
        let isSubscribed = true;
        if(presenter.resultsFramework && presenter.stepData && presenter.financialData && dimensionData && (!sectionData || presenter.stepTourFin === 2 || presenter.stepTourFin === 0)) {
            presenter.getFinancialData(presenter.resultsFramework, presenter.stepData, Number(projectData?.year))
        }
        return () => {(isSubscribed = false)}
    }, [presenter.resultsFramework, presenter.stepData, presenter.financialData, dimensionData, presenter.stepTourFin]);

    useEffect(() => {
        let isSubscribed = true;
        const canEdit = (screen === Enums.FollowupState.edit)
        if(dimensionData && presenter.subProjectDimensions && canEdit) {
            const isAllClosed: boolean = presenter.checkCloseMonths(dimensionData)
            const currentUser = presenter.getCurrentUser()
            
            const otherEdit = (!!dimensionData?.EnEdicion && currentUser.currentUser.userPrincipalName !== dimensionData?.PProaModifiedBy?.Name?.replace("i:0#.f|membership|", "")) || !dimensionData?.EnEdicion
            setAuxScreen((isAllClosed || otherEdit) ? Enums.FollowupState.view : screen)
        }
        return () => {(isSubscribed = false)}
    }, [presenter.subProjectDimensions, dimensionData, screen]);

    let visible = presenter.loadingFinished()
    let dimensionTour = (!presenter.tourFinSeen && dimensionData) ? presenter.getTourDimension(Enums.FollowupDimensions.financial, dimensionData) : null

    useEffect(() => {
        if(!presenter.tourFinSeen && presenter.stepTourFin === 1 && visible && activeTab === 2){
            Utilities.notifyTour(presenter.followupLabels.get("FinancialTourStep1"),
                presenter.followupLabels.get("tourWelcome"),
                `${presenter.followupLabels.get("tourBtnNext")} (${presenter.stepTourFin}/10)`,
                presenter.followupLabels.get("tourBtnSkip")
            )
            .then((res) => {
                if(res)presenter.changeStepTour(presenter.stepTourFin + 1, Enums.FollowupDimensions.financial);
                else setFinishTour(true)
            })
        }
    }, [presenter.tourFinSeen, presenter.stepTourFin, visible, activeTab]);

    useEffect(() => {
        if(finishTour){
            presenter.toggleTour(Enums.FollowupDimensions.financial, true)
            setFinishTour(false)
        }
    }, [finishTour]);

    const render = () => {
        if(!dimensionData) return <></>
        return (
            <Container fluid={true}>
                <Buttons 
                    initialValidate={initialValidate && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourFinSeen}
                    save={presenter.saveData} 
                    currentYear={Number(projectData?.year)} 
                    check={presenter.checkData} 
                    dimensionData={dimensionTour || dimensionData} 
                    followupLabels={presenter.followupLabels} 
                    formMasters={presenter.formMasters} 
                    step={3} 
                    screen={screen}
                    toggleEditing={presenter.toggleEditing}
                    currentUser={presenter.getCurrentUser()} 
                    startTour={() => presenter.toggleTour(Enums.FollowupDimensions.financial, false)}
                    stepTour={presenter.stepTourFin}
                />
                <FollowUpFinancialDetail 
                    initialValidate={initialValidate && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourFinSeen}
                    dataColumns={dataColumns}
                    tableAlert={presenter.tourFinSeen ? tableAlert : null}
                    section={Enums.FollowupBasicFields.resume}
                    sectionData={sectionData}
                    projectData={projectData}
                    status={dimensionData} 
                    screen={!presenter.tourFinSeen ? Enums.FollowupState.edit : auxScreen}
                    refresh={refresh}
                    saveTable={presenter.saveTable}
                />
                <FollowUpFinancialDetail 
                    initialValidate={initialValidate && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourFinSeen}
                    dataColumns={dataColumns}
                    tableAlert={presenter.tourFinSeen ? tableAlert : null}
                    section={Enums.FollowupBasicFields.activity}
                    sectionData={sectionData?.results}
                    projectData={projectData}
                    status={dimensionData} 
                    screen={!presenter.tourFinSeen ? Enums.FollowupState.edit : auxScreen}
                    refresh={refresh}
                    saveTable={presenter.saveTable}
                />
                <FollowUpFinancialDetail 
                    initialValidate={initialValidate && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourFinSeen}
                    dataColumns={dataColumns}
                    tableAlert={presenter.tourFinSeen ? tableAlert : null}
                    section={Enums.FollowupBasicFields.implementer}
                    sectionData={sectionData?.implementers[0]}
                    projectData={projectData}
                    status={dimensionData} 
                    screen={!presenter.tourFinSeen ? Enums.FollowupState.edit : auxScreen}
                    refresh={refresh}
                    saveTable={presenter.saveTable}
                />
                <FollowUpFinancialDetail
                    initialValidate={false} 
                    dataColumns={dataColumns}
                    tableAlert={presenter.tourFinSeen ? tableAlert : null}
                    section={Enums.FollowupBasicFields.location}
                    sectionData={sectionData?.locations[0]}
                    projectData={projectData}
                    status={dimensionData} 
                    screen={!presenter.tourFinSeen ? Enums.FollowupState.edit : auxScreen}
                    refresh={refresh}
                    saveTable={presenter.saveTable}
                />
                <FollowUpFinancialDetail 
                    initialValidate={initialValidate && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourFinSeen}
                    dataColumns={dataColumns}
                    tableAlert={presenter.tourFinSeen ? tableAlert : null}
                    section={Enums.FollowupBasicFields.adt}
                    sectionData={sectionData?.adts[0]}
                    projectData={projectData}
                    status={dimensionData} 
                    screen={!presenter.tourFinSeen ? Enums.FollowupState.edit : auxScreen}
                    refresh={refresh}
                    saveTable={presenter.saveTable}
                />
                <FollowUpFinancialDetail 
                    initialValidate={initialValidate && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourFinSeen}
                    dataColumns={dataColumns}
                    tableAlert={presenter.tourFinSeen ? tableAlert : null}
                    section={Enums.FollowupBasicFields.sdc}
                    sectionData={sectionData?.sdcs[0]}
                    projectData={projectData}
                    status={dimensionData} 
                    screen={!presenter.tourFinSeen ? Enums.FollowupState.edit : auxScreen}
                    refresh={refresh}
                    saveTable={presenter.saveTable}
                />
                {(visible && !presenter.tourFinSeen) &&
                    <AEAPopOver
                        popOverScroll={presenter.getScrollTour(presenter.stepTourFin, Enums.FollowupDimensions.financial)}
                        stepPosition={presenter.getPositionTour(presenter.stepTourFin, Enums.FollowupDimensions.financial)} 
                        visible={visible && !presenter.tourFinSeen} 
                        step={presenter.stepTourFin} 
                        totalStep={10}
                        changeStepTour={(step: number) => presenter.changeStepTour(step, Enums.FollowupDimensions.financial)}
                        finishTour={() => presenter.toggleTour(Enums.FollowupDimensions.financial, true)} 
                        labelDimension={'FinancialTourStep'} 
                        followupLabels={presenter.followupLabels}
                    /> 
                } 
            </Container>
        );       
    }
    return render();
}

export default FollowupFinancial;